export const ticketBasketHeaders = ["Bilet", "Atrakcje", "Cena", "Ilość", "Wartość", ""];
